module.exports = __webpack_public_path__ + "asset/image-iconCategoryEntertainment-e748a83e6d38cae3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/iconCategoryEntertainment.svg
// module id = /hAw
// module chunks = 0